import { useCallback } from "react";
import { type DecorativeTrailing, ListItem } from "@medbillai/ui";
import { issueUrl } from "@medbillai/utils/urls";
import { analyticsService } from "../../../lib/analytics";
import { useAuth } from "../../../lib/auth";
import type { Issue, IssueStatus } from "../utils/types";
import { cleanMarkdownText, formatEvent, getIssueStatus } from "../utils/utils";
const getIssueTrailing = (status: IssueStatus): DecorativeTrailing | undefined => {
  switch (status) {
    case "NEW_ACTIVITY":
      return {
        type: "pip"
      };
    case "CLOSED":
      return {
        type: "badge",
        status: "negative",
        children: "Closed"
      };
    case "PROCESSING":
      return undefined;
  }
};
export const CaseListItem = ({
  issue,
  selected,
  source
}: {
  issue: Issue;
  selected: boolean;
  source: string;
}) => {
  const {
    user
  } = useAuth();
  const status = getIssueStatus({
    closedAt: issue.closedAt,
    firstUnseenEventId: issue.firstUnseenEvent?.id
  });
  const lastEvent = issue.lastEvent;
  const eventContent = formatEvent(issue.firstUnseenEvent || lastEvent);
  const handlePress = useCallback(() => {
    if (user?.isShadow) {
      // Important: Don't track opened issue if we are shadowing
      return;
    }
    analyticsService.trackEvent("OpenedIssue", {
      issueId: issue.id,
      source
    });
  }, [issue.id, source, user?.isShadow]);
  return <ListItem testID={`case-list.item-${issue.id}`} title={issue.title || ""} subtitle={cleanMarkdownText(eventContent)} trailing={getIssueTrailing(status)} metadataDate={lastEvent?.sentAt} href={issueUrl({
    issueId: issue.id,
    unread: status === "NEW_ACTIVITY",
    title: issue.title
  })} onPress={handlePress} selected={selected} data-sentry-element="ListItem" data-sentry-component="CaseListItem" data-sentry-source-file="CaseListItem.tsx" />;
};